export const PROMPT_MIN_LEAD_DAYS = 14

// Identifies the prompt in its OWN analytics (Displayed).
export const PRICE_ALERT_PROMPT_COMPONENT = 'ProactivePriceAlertPrompt'

// `componentName` for the reused Price Watch action. We deliberately reuse the AP's
// persistent toggle name so the post-auth "enable after sign-in" completion fires:
// `usePriceWatchToggleLogic.enablePriceWatchAfterAuth` only runs on a *mounted* instance
// whose componentName matches the `componentPriceWatch` URL param / `pendingEnable.component`.
// Our prompt sheet is closed after the SUSI redirect, but the AP's `PriceWatchCTAWrapper
// componentName="PriceWatchToggle"` is still mounted and completes the enablement.
export const PRICE_WATCH_CTA_COMPONENT_NAME = 'PriceWatchToggle'

export const PRICE_ALERT_PROMPT_SURFACE = 'priceAlertPrompt'
